import {signal, WritableSignal} from '@angular/core';

export const phoneBannerVisibilitySignal: WritableSignal<boolean> = signal(false);
